import apiClient from './client';

export interface NotificationItem {
  id?: number;
  title?: string;
  message?: string;
  read?: boolean;
  createdAt?: string;
}

export const listNotifications = async (): Promise<{ success: boolean; data: NotificationItem[]; message?: string }> => {
  const response = await apiClient.get('/notifications');
  return response.data;
};
